import React, {useState, useEffect} from "react";
import {isEmpty} from "lodash";
import {Col, FormGroup, Input, ModalFooter, Row} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import {
  sendAddGroupModalData,
  sendEditGroupModalData,
  requestPermissionList,
  requestUserList,
} from "../../redux/Actions/group.action";
import {getPermissionList, getUsersList} from "../../redux/Selectors/group.selector";
import {useFetchGroups} from "../../views/Group/groupsTable/useGroupTableData";
import ZeusButton from "../Button";
import ProtectedContent, {usePermissionCheck} from "../protectedContent";
import SelectCreator from "./components/SelectCreator";

const DEFAULT_FORM_DATA = {name: "", permissions: [], users: []};

const GroupForm = (props) => {
  const {data, onCancel} = props;
  const dispatch = useDispatch();
  const {refetch} = useFetchGroups();
  const permission_list = useSelector(getPermissionList);
  const user_list = useSelector(getUsersList);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState(data || DEFAULT_FORM_DATA);
  const {name = "", permissions = [], users = []} = formData;

  const canViewUsers = usePermissionCheck(["view_user"]);
  const canViewPermissions = usePermissionCheck(["view_permission"]);

  useEffect(() => {
    if (canViewUsers) {
      dispatch(requestUserList());
    }
    if (canViewPermissions) {
      dispatch(requestPermissionList());
    }
  }, [canViewPermissions, canViewUsers, dispatch]);

  const onChangeHandler = (e) => {
    let updateObj = {...formData};
    updateObj = Object.assign({}, updateObj, {[e.target.name]: e.target.value});
    setFormData(updateObj);
  };

  const onFormSubmit = () => {
    setSubmitted(true);
    if (!isEmpty(name)) {
      const callback = () => {
        onCancel();
        refetch();
      };
      if (formData.id) {
        dispatch(sendEditGroupModalData(formData, callback));
      } else {
        dispatch(sendAddGroupModalData(formData, callback));
      }
    } else {
      toast.error("Name is required!");
    }
  };

  return (
    <>
      <div>
        <div className="pl-lg-4">
          <Row>
            <Col lg="12">
              <FormGroup>
                <label className="form-control-label" htmlFor="name">
                  NAME <span className="text-red">*</span>
                </label>
                <Input
                  className="form-control-alternative"
                  // defaultValue="United States"
                  id="name"
                  placeholder="name"
                  type="text"
                  data-cy={"group_name"}
                  value={name}
                  invalid={isEmpty(name) && submitted}
                  name="name"
                  onChange={onChangeHandler}
                />
              </FormGroup>
            </Col>

            <ProtectedContent perms={["view_permission"]}>
              <SelectCreator
                label={"PERMISSIONS"}
                closeMenuOnSelect={false}
                options={permission_list}
                onChange={onChangeHandler}
                value={permissions}
                classNamePrefix={"select_permissions"}
                id={"select_permissions"}
                name="permissions"
                large
                isMulti
                isSearchable
              />
            </ProtectedContent>
            <ProtectedContent perms={["view_user"]}>
              <SelectCreator
                label={"USER"}
                closeMenuOnSelect={false}
                options={user_list}
                onChange={onChangeHandler}
                value={users}
                classNamePrefix={"select_users"}
                id={"select_users"}
                name="users"
                large
                isMulti
                isSearchable
              />
            </ProtectedContent>
          </Row>
        </div>
      </div>
      <ModalFooter>
        <ZeusButton data-cy="submit-btn" onClick={onFormSubmit}>
          SUBMIT
        </ZeusButton>
        <ZeusButton onClick={onCancel} data-cy={"cancel-btn"} className="info-small">
          CANCEL
        </ZeusButton>
      </ModalFooter>
    </>
  );
};

export default GroupForm;
